import {BooleanRouteOption} from './boolean-route-option';
import {ActivatedRouteSnapshot} from '@angular/router';
import {FinancialHealthSeriesOption} from '../financial-health-series';

export class DisplayGovTypeMeanRouteOption extends BooleanRouteOption {
	constructor(
		route: ActivatedRouteSnapshot,
		defaultValue = false,
		public annotation: string = '',
	) {
		super(
			FinancialHealthSeriesOption.displayGovTypeMean,
			route,
			defaultValue
		);
	}
}
